export const DEFAULT_REM_PX_SIZE = 16;

export const MAX_BREAKPOINTS = {
  LARGE_SCREEN: 1535,

  LAPTOP: 1300,

  TABLET: 1090,

  MID_TABLET: 980,

  SMALL_TABLET: 767,

  PHONE: 534,

  SMALL_PHONE: 390,
};

type Breakpoints = typeof MAX_BREAKPOINTS;

export const QUERIES = {
  ...(Object.fromEntries(
    Object.entries(MAX_BREAKPOINTS).map(([key, width]) => [
      key,
      `@media(max-width: ${width / DEFAULT_REM_PX_SIZE}rem)`,
    ]),
  ) as Record<keyof Breakpoints, string>),

  // ONLY_TABLET: `@media(max-width: ${
  //   MAX_BREAKPOINTS.ONLY_TABLET / DEFAULT_REM_PX_SIZE
  // }rem) and (min-height: 950px)`,

  CUSTOM: (width: number): string => `@media(max-width: ${width / DEFAULT_REM_PX_SIZE}rem)`,

  BETWEEN: (low: number, high: number): string =>
    `@media (min-width: ${low / DEFAULT_REM_PX_SIZE}) and (max-width: ${
      high / DEFAULT_REM_PX_SIZE
    }rem)`,

  HOVER_ENABLED: `@media (hover: hover) and (pointer: fine)`,
};

export type ResponsiveBreakpoint = keyof Breakpoints;
